import { Dialog, Image } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util'
import SecurityCodeHelpPng from '@images/security_code_help.webp'

export const SecurityCodePopupModal = ({ isOpen, onClose }) => (
  <Dialog.Root open={isOpen} onOpenChange={(details) => !details.open && onClose()}>
    <Dialog.Backdrop />
    <Dialog.Positioner>
      <Dialog.Content>
        <Dialog.Header>セキュリティコードについて</Dialog.Header>
        <Dialog.CloseTrigger />
        <Dialog.Body>
          セキュリティコードは、クレジットカードの裏面に記載されている3桁または4桁の数字です。
          <Image src={buildAssetUrlString(SecurityCodeHelpPng)} />
        </Dialog.Body>
      </Dialog.Content>
    </Dialog.Positioner>
  </Dialog.Root>
)
